const codingTemplate = {
  coding_template: "Coding Template",
  coding_templates: "Coding Templates",
  add_coding_template: "Add Coding Template",
  edit_coding_template: "Edit Coding Template",
  name: "Name",
  description: "Description",
  actions: "Actions",
  supplier: "Supplier",
  supplier_name: "Supplier Name",
  select_supplier: "Select supplier",
  select_dimension_value: "Select value",
  default: "Default",
  allocations: "Allocations",
  add_allocation: "Add Allocation",
  percentage: "Percentage",
  cancel: "Cancel",
  save: "Save",
  add: "Add",
  update: "Update",
  something_went_wrong: "Something went wrong",
  no_coding_templates_found: "No coding templates found",
  service_invoice_tags: "Service Invoice Tags",
  supplier_service_tags_not_defined: "Service tags aren't defined for this supplier.",
  coding_template_supplier_hint:
    "If no supplier is selected, this template will be used as the Default Template for your organization.",
  coding_template_allocations_description:
    "Split the invoice amount across dimensions. Percentages across all allocations must add up to 100.",
  coding_template_name_required: "Name is required",
  coding_template_description_max_length:
    "Description must be at most 500 characters",
  coding_template_percentage_required: "Percentage is required",
  coding_template_percentage_range: "Percentage must be between 0 and 100",
  coding_template_allocation_required: "At least one allocation is required",
  coding_template_dimension_required:
    "Select at least GL Account dimension value for this allocation",
  coding_template_percentage_sum_error:
    "The sum of all allocation percentages must equal 100",
  coding_template_created_successfully: "Coding template created successfully",
  coding_template_updated_successfully: "Coding template updated successfully",
  coding_template_deleted_successfully: "Coding template deleted successfully",
  delete_coding_template_title: "Delete Coding Template",
  delete_coding_template_description:
    "Are you sure you want to delete this coding template?",
  glaccount_dimension_not_configured: "GL Account Dimension has not configured",
  accrual_period: "Accrual Period",
  coding_template_accrual_period_range:
    "Accrual Period must be between 1 and 12",
  coding_template_accrual_period_hint:
    "Accrual period is based on month and its value is between 1 and 12",
  config: "Configuration",
  config_hint: "By default coding template split on Total Without Tax, but you change it from here",
  enable_split_on_total_amount: "Enable split on Total Amount",
  config_subtitle: "Choose where the allocation percentages are applied.",
  split_on: "Split on",
  split_on_invoice_total: "Invoice total",
  split_on_tax_line: "Each tax line",
  split_on_tax_line_hint:
    "Allocation percentages are applied to each tax line of the taxes table separately (its taxable base and tax), so every tax rate is split across the same dimensions.",
};

export default codingTemplate;
